import { forwardRef } from 'react';
import { NumberFormatBaseProps, NumberFormatValues } from 'react-number-format';
import { Toast } from '@/lib/Toast';
import { TextField, TextFieldProps, InputAdornment } from '@mui/material';
import MicroInputBase from './microInputBase';

interface CurrencyInputMicroProps {
  inputType?: 'currency' | 'quantity';
  onChangeMicroValue?: (microValue: number) => void;
  textAlign?:
    | 'start'
    | 'end'
    | 'left'
    | 'right'
    | 'center'
    | 'justify'
    | 'match-parent';
}
const MicroCurrencyInput = forwardRef<
  TextFieldProps,
  CurrencyInputMicroProps & NumberFormatBaseProps & TextFieldProps
>((props, ref) => {
  const {
    onChangeMicroValue,
    textAlign = 'end',
    value,
    InputProps,
    variant = 'outlined',
    inputType = 'currency',
    fullWidth = true,
    sx,
    ...otherProps
  } = props;

  const handleChangeValues = ({ value, floatValue }: NumberFormatValues) => {
    if (floatValue && floatValue < 0)
      return Toast('error', 'Valor não pode ser negativo');

    if (floatValue && floatValue > Number.MAX_SAFE_INTEGER) return;

    if (onChangeMicroValue)
      onChangeMicroValue(Math.round(Number(value) * 10000));
  };

  return (
    <TextField
      {...otherProps}
      fullWidth={fullWidth}
      variant={variant}
      sx={{
        '& .MuiInputBase-input': {
          textAlign,
        },
        ...sx,
      }}
      InputProps={{
        ...InputProps,
        inputComponent: MicroInputBase as never,
        inputProps: {
          onValueChange: handleChangeValues,
          value: value ? Number(value) / 10000 : 0,
          ...InputProps?.inputProps,
        },
        ref: ref,
        startAdornment: InputProps?.startAdornment ? (
          InputProps.startAdornment
        ) : inputType === 'currency' ? (
          <InputAdornment position="start">R$</InputAdornment>
        ) : undefined,
      }}
    />
  );
});
MicroCurrencyInput.displayName = 'MicroCurrencyInput';

export default MicroCurrencyInput;
